export const getPositiveNumberParam = (value: string | null): number | null => {
  if (!value) return null;

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue) || parsedValue <= 0) return null;

  return parsedValue;
};
